import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MydacComponent } from './mydac/mydac.component';
import { ComplianceReviewComponent } from './compliance-review/compliance-review.component';
import { ArchivedcurrentdocumentsComponent } from './archivedcurrentdocuments/archivedcurrentdocuments.component';
import { ContinuingeducationComponent } from './continuingeducation/continuingeducation.component';

import { DmcaComponent } from './dmca/dmca.component';
import { LegalInformationComponent } from './LegalInformation/legal-information.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { HelpComponent } from './help/help.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { BrowseObligorComponent } from './browse-obligor/browse-obligor.component';

import { IssuersandObligorsComponent } from './IssuersandObligors/issuersand-obligors.component';
import { DACForInvestorsComponent } from './DACForInvestors/dacfor-investors.component';

import { ReviewtoolkitComponent } from './reviewtoolkit/reviewtoolkit.component';
import { LoginComponent } from './login/login.component';
import { CusipComponent } from './cusip/cusip.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { PandpcusipComponent } from './pandpcusip/pandpcusip.component';
import { from } from 'rxjs';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'compliance-review', component: ComplianceReviewComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'dmca', component: DmcaComponent },
  { path: 'legal-information', component: LegalInformationComponent },
  { path: 'aboutus', component: AboutusComponent },
  { path: 'help', component: HelpComponent },
  { path: 'archivedcurrentdocuments', component: ArchivedcurrentdocumentsComponent },
  { path: 'continuingeducation', component: ContinuingeducationComponent },
  { path: 'browse-obligor', component: BrowseObligorComponent },

  { path: 'IssuersandObligors', component: IssuersandObligorsComponent },
  { path: 'DACForInvestors', component: DACForInvestorsComponent },

  { path: 'reviewtoolkit', component: ReviewtoolkitComponent },
  { path: 'mydac', component: MydacComponent },
  { path: 'login', component: LoginComponent },
  { path: 'cusip', component: CusipComponent },
  { path: 'forgotpassword', component: ForgotpasswordComponent },
  { path: 'resetpassword', component: ResetpasswordComponent },
  { path: 'pandpcusip', component: PandpcusipComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
